module.exports = __webpack_public_path__ + "static/media/falabella.96209652.webp";